import React, { useState, useContext, useEffect, useRef, useCallback } from 'react';
import { Form, Row, Col, Button, Image } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { Offcanvas } from 'react-bootstrap';
import SearchCoordinadora from '../Localizacion/SearchCoordinadora';
//import MapComp from './MapComp';
import GoogleMapContainer from './GoogleMapContainer';
import MapContext from "../../context/MapContext";
import AlldataComp from '../../context/AlldataComp';
import PositionContext from '../../context/PositionContext';
import ViewContext from '../../context/ViewContext';
import LoadingTailwindContext from '../../context/LoadingTailwindContext';
import LoadingTailwindComp from '../Shared/LoadingTailwindComp';
import AlertImageContext from '../../context/AlertImageContext';
import RenapoContext from '../../context/RenapoContext';
import { Setting } from '../../config';
import axios from 'axios';

import '../../Styles/Location.css';

const ServerRoute = Setting.API_URL;

function Localizacion() {

    const [dataRenapo, setdataRenapo] = useContext(RenapoContext);
    const [dataMap, setDataMap] = useContext(MapContext);
    const [position,] = useContext(PositionContext);
    const [dataLoadingTailwind, setdataLoadingTailwind] = useContext(LoadingTailwindContext);
    const inputStreet = useRef();
    const [show, setShow] = useState(false);
    const [showCPMsg, setShowCPMsg] = useState(false);
    const [showErrorCoord, setshowErrorCoord] = useState(false);
    const [showErrorReferido, setShowErrorReferido] = useState(false);
    const [showErrorColony, setShowErrorColony] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [dataUrl, setDataUrl] = useState({ 'refresh': '', 'utm_source': '', 'utm_medium': '', 'utm_campaign': '' });

    const { register: registerLocalizacion, formState: { errors: errors2 }, handleSubmit: handleSubmit2, } = useFormContext();
    const [dataAlldataComp, setAlldataComp] = useContext(AlldataComp);
    const [, setdataView] = useContext(ViewContext);
    const [, setAlertImageData] = useContext(AlertImageContext);

    const Loading = useCallback((boolLocation, boolLoading, label) => {
        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: boolLocation, loading: boolLoading, label: label }))
    }, [setdataLoadingTailwind])

    const addInputStreetToMapContext = useCallback(
        () => {
            setDataMap(dataMap => dataMap = { ...dataMap, inputStreet });
        },
        [setDataMap]
    )

    useEffect(() => {
        document.getElementById("titleFormulario").scrollIntoView();
        const searchParams = new URLSearchParams(window.location.search)
        const refresh = searchParams.get('refresh')
        const utm_source = searchParams.get('utm_source')
        const utm_medium = searchParams.get('utm_medium')
        const utm_campaign = searchParams.get('utm_campaign')

        setDataUrl({
            refresh,
            utm_source,
            utm_medium,
            utm_campaign
        })
    }, [])

    useEffect(() => {
        addInputStreetToMapContext();
    }, [addInputStreetToMapContext])

    const onClickCancelar = () => {
        setdataView('DP');
    }

    const onSubmit = async data => {
        let errorBool = false;
        const submit_ = async () => {
            async function Axios_ListaZonasService(lat, lng) {
                let resp = axios.get(`${ServerRoute}Service/ListaZonasService`,
                    { params: { lat: lat, lng: lng } },
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'origin': 'x-requested-with',
                            'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
                            'Content-Type': 'application/json',
                        }
                    })
                return resp;
            }

            Loading(true, true, "Estamos ubicando su zona, espere por favor...");
            //setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: true, loading: true, label: "Estamos ubicando su zona, espere por favor..." }))
            let coordenadas = dataMap.Coords
            let respZonas = await Axios_ListaZonasService(coordenadas.CoordY, coordenadas.CoordX)

            if (respZonas.status === 200 || respZonas.data.code === 200) {
                if ((respZonas.data.data).length !== 0) {

                    const Setdata = () => {
                        Loading(false, false, "");
                        let ContactObj = {};
                        ContactObj = dataAlldataComp.Contact;
                        ContactObj.AvisoResp = data.AvisoPrivacidad_a;
                        ContactObj.Medio = data.ComoLlego;
                        ContactObj.Refirio = dataRenapo.Referido;
                        ContactObj.TerminosResp = data.AvisoPrivacidad_b;
                        let CurrentLocationObj = {};
                        CurrentLocationObj.Calle = data.calle;
                        CurrentLocationObj.Ciudad = dataMap.locality;
                        CurrentLocationObj.Colonia = data.Colonia;
                        CurrentLocationObj.EntreCalles = data.EntreCalles;
                        CurrentLocationObj.Estado = dataMap.state;
                        CurrentLocationObj.Municipio = dataMap.municipality;
                        CurrentLocationObj.NumExterior = data.NumExterior;
                        CurrentLocationObj.NumInterior = !data.NumInterior ? '' : data.NumInterior;
                        CurrentLocationObj.Referencia = !data.Referencia ? '' : data.Referencia;
                        CurrentLocationObj.Latitud = coordenadas.CoordY;
                        CurrentLocationObj.Longitud = coordenadas.CoordX;
                        CurrentLocationObj.CheckINE = !!data.CheckINE;
                        CurrentLocationObj.CP = data.CP;

                        let CoordInfoObj = {};
                        if (dataRenapo.Referido == 'true') {
                            CoordInfoObj.CuentaColectiva = parseInt(dataRenapo.CoordinadoraData);
                            CoordInfoObj.Nombre = dataRenapo.CoordinadorName;
                        }
                        else {
                            CoordInfoObj.CuentaColectiva = 0;
                            CoordInfoObj.Nombre = '';
                        }
                        setAlldataComp((item) => ({ ...item, Contact: ContactObj, CurrentLocation: CurrentLocationObj, CoordInfo: CoordInfoObj }))
                    };
                    const ChangeView = () => {
                        setdataView('SMS');
                    }

                    await Setdata();
                    await ChangeView();
                }
                else {
                    
                    let urlOrigen = '';
                    let location = window.location.href
                    if (location.split('?')[1]) {
                        let existOrigin = location.split('?')[1].includes('origen');
                        if (existOrigin) {
                            urlOrigen = location.split('?')[1].split('=')[1]
                        }
                    }


                    let formData = new FormData();
                    formData.append("correo", dataRenapo.Correo)
                    formData.append("Motivo", 3)
                    formData.append("celular", dataRenapo.Celular)
                    formData.append("origen", urlOrigen)
                    formData.append("refresh", dataUrl.refresh)
                    formData.append("utm_source", dataUrl.utm_source)
                    formData.append("utm_medium", dataUrl.utm_medium)
                    formData.append("utm_campaign", dataUrl.utm_campaign)
                    fetch(`${ServerRoute}Service/LogCorreo`,
                        {
                            method: "post",
                            mode: 'cors',
                            body: formData
                        })

                    setAlertImageData(item => ({
                        ...item,
                        src: "https://webfullerette.fuller.com.mx/Content/img/Popup-rechazadas/COBERTURA/Imagen_Cobertura.png",
                        title: "FUERA DE COBERTURA",
                        body: "Lo sentimos, en este momento no puedes ingresar a Fuller ya que, NO TENEMOS COBERTURA EN TU ÁREA.",
                        body2: "",
                        bodyfotter: "¡ Te aseguramos que estamos trabajando para llegar a tu comunidad muy pronto !",
                        bool: true,
                        scneario: "FC",
                        dataFullerette: {},
                        dataCoordinadora: {},
                        dataGerente: {}
                    }))

                }

            }
            else {
                setAlertImageData(item => ({
                    ...item,
                    src: "https://webfullerette.fuller.com.mx/Content/img/Popup-rechazadas/COBERTURA/Imagen_Cobertura.png",
                    title: "FUERA DE COBERTURA",
                    body: "Lo sentimos, en este momento no puedes ingresar a Fuller ya que, NO TENEMOS COBERTURA EN TU ÁREA.",
                    body2: "",
                    bodyfotter: "¡ Te aseguramos que estamos trabajando para llegar a tu comunidad muy pronto !",
                    bool: true,
                    scneario: "FC",
                    dataFullerette: {},
                    dataCoordinadora: {},
                    dataGerente: {}
                }))
            }
        }

        if (dataRenapo.Colony == 'Colonia *') {
            setShowErrorColony(true);
            errorBool = true;
        } else {
            setShowErrorColony(false);

        }

        if (dataRenapo.Referido != '') {
            setShowErrorReferido(false);

            if (dataRenapo.Referido == 'true') {
                if (!dataRenapo.CoordinadorName) {
                    setshowErrorCoord(true);
                    errorBool = true;
                }
                else {
                    await setshowErrorCoord(false);

                }
            }
            else {
                await setshowErrorCoord(false);

            }
        } else {
            setShowErrorReferido(true);
            errorBool = true;
        }
        if (!errorBool) {
            await submit_();
        }
    }

    const handleBlurCP = async (e) => {
        const cp = e.target.value;
        let c_p = cp.length == 4 ? `0${cp}` : cp;
        const regex = /^[0-9]{5}$/;
        let validate = c_p.match(regex);
        if (validate) {
            axiosGetEstadosEspecificos(c_p);
            setShowCPMsg(false);
        } else {
            e.target.value = '';
            setShowCPMsg(true);
        }
    }

    const axiosGetEstadosEspecificos = useCallback(async (zipCode) => {
        const ArrayColonias = [];
        try {

            const response = await axios.get(ServerRoute + "Service/ObtenerEstadosEspecificos", { params: { codigoPostal: zipCode } });
            if (response.status === 200) {
                if (response.data.code === 200) {
                    var respCol = await axiosGetColonias(response.data.list[0].ciudad, response.data.list[0].entidad, zipCode)
                    var obj = {};
                    if (respCol.data.code === 200) {
                        setDataMap(data => data = {
                            ...data,
                            state: response.data.list[0].estado,
                            municipality: response.data.list[0].ciudad,
                            locality: response.data.list[0].ciudad,
                            Coords: response.data.Coords
                        })

                        for (var i = 0; i < respCol.data.colonias.length; i++) {
                            obj = {
                                'Colonia': respCol.data.colonias[i].colonia
                            }
                            ArrayColonias.push(obj);
                        }
                        //setdataRenapo({ ...dataRenapo, Colony: ArrayColonias[0].Colonia })
                    }


                    setDataMap(data => data = { ...data, colony: ArrayColonias })
                }
                else {
                    console.log("Error", response);

                }
            }
            return ArrayColonias;
        } catch (e) {
            console.error();
            return [];
        }

    }, [])

    const axiosGetColonias = (strClaveCiudad, idEntidad, strCP) => {

        try {
            return axios.get(ServerRoute + 'Service/ObtenerColonias', {
                params: {
                    strClaveCiudad: strClaveCiudad,
                    idEntidad: idEntidad,
                    strCP: strCP
                }
            })
        }
        catch (e) {
            return -1;
        }
    }

    return (
        <div>
            {
                dataLoadingTailwind.loading ? (<LoadingTailwindComp label={dataLoadingTailwind.label} />) :
                    (
                        <Form key={2} onSubmit={handleSubmit2(onSubmit)}>
                            <div className='row'>
                                <div className='col-12 mb-4 form_subtitle'>
                                    <label className="font-weight-bold form_subtitle-label">Localización</label> <br />
                                    <label className='form_label-oblugatorio'>Los campos marcados con <span className="span-blue">*</span> <span className="">son obligatorios</span></label>
                                </div>

                                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                    <Form.Group className="mb-3">

                                        <Form.Control className="simple-field form_input_new" type="CP"
                                            name="CP"
                                            {...registerLocalizacion("CP", {
                                                required: true,
                                                maxLength: 5,
                                                value: dataMap.zipCode,
                                                pattern: { value: /[0-9]{0,4}/ },
                                                onBlur: handleBlurCP,
                                                onChange: (e) => { setDataMap(data => data = { ...data, zipCode: e.target.value }) }
                                            })}
                                            value={dataMap.zipCode}
                                            placeholder='Código postal *'
                                            maxLength={5}
                                        />
                                        {showCPMsg && <label className="mandatory">¡Código Postal necesario! Favor de ingresar un C.P válido</label>}
                                        {/* {errors2?.CP && <label className="mandatory">¡Código Postal necesario! Favor de ingresar un C.P válido</label>} */}
                                    </Form.Group>
                                </div>
                                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                    <Form.Group className="mb-3">

                                        <Form.Control className="simple-field form_input_new" type="text"
                                            name="Estado" {...registerLocalizacion("Estado", {
                                                maxLength: 50,
                                                value: dataMap.state,
                                                onChange: (e) => { setDataMap(data => data = { ...data, state: e.target.value }) },
                                            })}
                                            value={dataMap.state}
                                            readOnly={true}
                                            maxLength={50}
                                            placeholder='Estado'
                                        />
                                        {!dataMap.state && <label className="mandatory">¡Estado necesario! Favor de ingresar un Estado válido</label>}
                                    </Form.Group>
                                </div>
                                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                    <Form.Group className="mb-3">

                                        <Form.Control className="simple-field form_input_new" type="text"
                                            name="Municipio" {...registerLocalizacion("Municipio", {
                                                maxLength: 50,
                                                value: dataMap.municipality,
                                                onChange: (e) => { setDataMap(data => data = { ...data, municipality: e.target.value }) }
                                            })}
                                            value={dataMap.municipality}
                                            readOnly={true}
                                            maxLength={50}
                                            placeholder='Municipio'
                                        />
                                        {!dataMap.municipality && <label className="mandatory">¡Municipio necesario! Favor de ingresar un Municipio válido</label>}
                                    </Form.Group>
                                </div>
                                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                    <Form.Group className="mb-3">

                                        <Form.Control className="simple-field form_input_new" type="text"
                                            name="Ciudad_Poblacion" {...registerLocalizacion("Ciudad_Poblacion", {
                                                maxLength: 50,
                                                value: dataMap.locality,
                                                onChange: (e) => { setDataMap(data => data = { ...data, locality: e.target.value }) }
                                            })}
                                            value={dataMap.locality}
                                            readOnly={true}
                                            maxLength={50}
                                            placeholder='Ciudad/Población'
                                        />
                                        {!dataMap.locality && <label className="mandatory">¡Ciudad/Población necesario! Favor de ingresar una Ciudad o Población válida</label>}
                                    </Form.Group>
                                </div>

                            </div>

                            <div className='row'>
                                <div className='col-12 mb-4 form_subtitle'>
                                    <label className="font-weight-bold form_subtitle-label">Dirección</label> <br />

                                </div>
                                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <Form.Group className="mb-3">

                                        <Form.Select
                                            className="simple-field form_select_new"
                                            name="colonia"
                                            {...registerLocalizacion("Colonia", {
                                                value: dataRenapo.Colony,
                                                onChange: (e) => setdataRenapo(item => ({ ...item, Colony: e.target.value }))
                                            })}>
                                            <option disabled>Colonia *</option>
                                            {
                                                dataMap.colony.map((colony, i) => <option key={i} value={colony.Colonia}>{colony.Colonia}</option>)
                                            }
                                        </Form.Select>
                                        {(dataRenapo.Colony == 'Colonia *') && <label className="mandatory">¡Colonia necesaria! Favor de ingresar una Colonia válida</label>}
                                    </Form.Group>
                                </div>

                                <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8'>
                                    <Form.Group className="mb-3">
                                        {/* <Form.Label className="font-weight-bold">Calle (Puedes buscar colocando tu calle con tu número y tienes que seleccionar de las opciones la dirección correcta)
                                            <Button variant="Link" onClick={handleShow} className="me-2" >
                                                <span className="span-blue"> <FontAwesomeIcon icon={faQuestionCircle} /> *</span>
                                            </Button>
                                            <Offcanvas show={show} onHide={handleClose} placement="end" className="text-center" >
                                                <Offcanvas.Header closeButton >
                                                    <Offcanvas.Title  >Puedes buscar colocando tu calle con tu número y tienes que seleccionar de las opciones la dirección correcta  </Offcanvas.Title>
                                                </Offcanvas.Header>
                                                <Offcanvas.Body>
                                                    <Image className="image-search" src=" https://webfullerette.fuller.com.mx/Content/img/search-google.gif" alt="image-search" />
                                                </Offcanvas.Body>
                                            </Offcanvas>
                                        </Form.Label> */}

                                        <Form.Control id="input-street" className="simple-field form_input_new" type="text"
                                            autoComplete="off"
                                            maxLength={150}
                                            name="calle"
                                            {...registerLocalizacion("calle", {
                                                required: true,
                                                value: dataMap.streetName,
                                                maxLength: 150,
                                                onChange: (e) => {
                                                    setDataMap(data => data = { ...data, streetName: e.target.value })
                                                }
                                            })}
                                            value={dataMap.streetName}
                                            placeholder='Calle *'
                                        // ref={inputStreet}
                                        />
                                        {errors2?.calle && <label className="mandatory">¡Calle necesaria! Favor de ingresar una Calle válida</label>}
                                    </Form.Group>
                                </div>
                            </div>


                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>

                                    <Form.Group className='mb-3'>
                                        <Form.Control className="simple-field form_input_new" type="text"
                                            name="NumExterior" {...registerLocalizacion("NumExterior", {
                                                required: true,
                                                maxLength: 100,
                                                value: dataMap.streetNumber,
                                                onChange: (e) => { setDataMap(data => data = { ...data, streetNumber: e.target.value }) },
                                                onKeyup: (e) => { setDataMap(data => data = { ...data, streetNumber: e.target.value }) }
                                            })}
                                            value={dataMap.streetNumber}
                                            placeholder='No. Exterior *'
                                        />
                                        {errors2.NumExterior?.type === 'required' && <label className="mandatory">¡Dato necesario! Favor de ingresar un Número Exterior válido</label>}
                                    </Form.Group>
                                </div>
                                {/* <div className='col-2'>
                                    <Form.Group className='mb-3'>

                                        <Form.Control className="simple-field form_input_new" type="text"
                                            name="NumInterior" {...registerLocalizacion("NumInterior", { maxLength: 100 })}
                                            maxLength={100}
                                            placeholder='Núm. Interior'
                                        />
                                    </Form.Group>
                                </div> */}
                                <div className='col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-10'>

                                    <Form.Group className="mb-3">

                                        <Form.Control className="simple-field form_input_new" type="text"
                                            maxLength="100"
                                            name="EntreCalles" {...registerLocalizacion("EntreCalles")}
                                            placeholder='Entre calles 2'
                                        />
                                    </Form.Group>
                                </div>
                            </div>

                            {/* <div className='row'>
                                <div className='col-12'>
                                    <Form.Group className="mb-3">

                                        <Form.Control className="simple-field form_input_new" type="text"
                                            name="Referencia" {...registerLocalizacion("Referencia")}
                                            placeholder='Referencia'
                                        />
                                        
                                    </Form.Group>
                                </div>
                            </div> */}


                            {/* <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold"><mark className="mark">Por favor, indica en el mapa la ubicación exacta del domicilio, ya que será el lugar en el cúal te estaremos entregando todos los pedidos <span className="span-blue">*</span></mark></Form.Label>
                                <GoogleMapContainer />
                            </Form.Group> */}
                            <div className='row'>

                                <div className='col-12 mb-3 form_subtitle'>
                                    <label className="font-weight-bold form_subtitle-label">Referencia</label> <br />
                                    <Form.Label className="font-weight-bold">¿Alguien te refirió? <span className="">*</span></Form.Label>

                                </div>

                            </div>

                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                    <Button className={`w-100 form_button_new_2 ${dataRenapo.Referido == 'true' && 'active'}`} type='button'
                                        onClick={() => {
                                            setdataRenapo(item => ({ ...item, Referido: 'true' }))
                                        }
                                        }
                                    >
                                        Sí
                                    </Button>
                                </div>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                    <Button className={`w-100 form_button_new_2 ${dataRenapo.Referido == 'false' && 'active'}`}
                                        onClick={() => {
                                            setdataRenapo(item => ({ ...item, Referido: 'false' }))
                                        }
                                        }
                                    >
                                        No
                                    </Button>
                                </div>
                            </div>
                            <div className='mb-3'>
                                {showErrorReferido && <label className="mandatory">¡Dato necesario! Favor de ingresar Referencias válidas</label>}
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    {
                                        dataRenapo.Referido == 'true' ? (
                                            <Form.Group className="mb-3">

                                                <SearchCoordinadora />
                                            </Form.Group>

                                        ) : null
                                    }
                                    {(showErrorCoord ? (<label className="mandatory">¡ Dato necesario ! Favor de seleccionar a la Coordinadora </label>) : null)}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold form_subtitle-label">¿Cómo llegaste a este formulario? <span className="">*</span></Form.Label>
                                        <Form.Select
                                            className="simple-field"
                                            {...registerLocalizacion("ComoLlego", {
                                                required: true,
                                            })}>

                                            <option value="Facebook">Facebook</option>
                                            <option value="Google">Google</option>
                                            <option value="Instagram">Instagram</option>
                                            <option value="Youtube">Youtube</option>
                                            <option value="Folleto">Folleto</option>
                                            <option value="Call Center">Call Center</option>
                                            <option value="Otro">Otro</option>
                                        </Form.Select>

                                        {(errors2.ComoLlego?.type === 'required' ? (<label className="mandatory">¡Dato necesario ! Favor de seleccionar una opción </label>) : null)}
                                    </Form.Group>


                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <Form.Group className="flexbox-termconditions">
                                        <Form.Check
                                            type="checkbox"
                                            id={`default-checkbox`}
                                            {...registerLocalizacion("AvisoPrivacidad_a", {
                                                required: false,
                                            })}
                                        />
                                        <Form.Check.Label className="label-terms">
                                            La dirección registrada corresponde a la dirección de mi INE
                                        </Form.Check.Label>

                                    </Form.Group>

                                    <Form.Group className="flexbox-termconditions">
                                        <Form.Check
                                            type="checkbox"
                                            id={`default-checkbox`}
                                            {...registerLocalizacion("CheckINE", {
                                                required: false,
                                            })}
                                        />
                                        <Form.Check.Label className="label-terms">
                                            Manifiesto que he leído y entiendo el Aviso de Privacidad que en cumplimiento a lo previsto en
                                            la Ley Federal de Protección de Datos Personales en Posesión de Particulares ha puesto a mi disposición
                                            la empresa <span className="font-weight-bold">House of Fuller S. de R.L. de C.V.</span>, el cual podré consultar en todo momento en el sitio
                                            <a className="checkbox-entry" rel="noopener noreferrer" target="a_blank" href="https://fuller.com.mx/legales.html"> Aviso de Privacidad</a>
                                        </Form.Check.Label>

                                    </Form.Group>

                                    <Form.Group className="flexbox-termconditions">
                                        <Form.Check
                                            type="checkbox"
                                            id={`default-checkbox-two`}
                                            {...registerLocalizacion("AvisoPrivacidad_b", {
                                                required: true,
                                            })}
                                        />
                                        <Form.Check.Label className="label-terms">
                                            Acepto que <span className="font-weight-bold">FULLER</span> trate mis datos personales para las finalidades secundarias mencionadas en el
                                            <a className="checkbox-entry" target="a_blanck" rel="noopener noreferrer" href="https://fuller.com.mx/legales.html"> Aviso de Privacidad</a>
                                        </Form.Check.Label>

                                    </Form.Group>
                                    {(errors2.AvisoPrivacidad_a?.type === 'required' || errors2.AvisoPrivacidad_b?.type === 'required') && <label className="mandatory">¡Dato necesario! Favor de aceptar ambos Avisos de Privacidad </label>}

                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-12'>
                                    <div className='content_form-button'>
                                        <Form.Group className="mb-3">
                                            <Button
                                                className="form_button_new" type="submit">Siguiente
                                            </Button>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </Form>

                    )
            }  </div>
    )
}


export default Localizacion;